import { mapState } from 'vuex';
import { Base64 } from 'js-base64';
import { apiCallers } from '@/api/apiRequest';
import { required, email } from 'vuelidate/lib/validators';

import AssetImage from '@/components/common/asset-image.vue';
import InsuranceCard from '@/components/common/insurance-card.vue';
import AssetHandler from '@/mixins/assetHandler.js';
import ScrollHandler from '@/mixins/scrollHandler.js';
import TrackingHandler from '@/mixins/trackingHandler.js';

export default {
  components: {
    AssetImage,
    InsuranceCard
  },

  mixins: [
    AssetHandler,
    ScrollHandler,
    TrackingHandler
  ],

  data () {
    return {
      insurances: [],
      cardIndex: 0,
      housingIndex: 0,
      educationIndex: 0,
      agreeChecked: false,
      emailAddress: '',
      showError: false,
      showMailHint: false,
      sendTimeoutId: null,
      mailRequestSent: false,
      /* global __CURRENT_BUILDTARGET */
      buildTarget: __CURRENT_BUILDTARGET,

			cards: [{
				index: 1,
				title: 'Ich starte ins Berufsleben.',
        iconName: 'startBerufsleben.png',
        name: 'start-berufsleben',
        tracking_name: '01/start_berufsleben'
			},{
				index: 2,
				title: 'Ich beginne eine Ausbildung oder ein Studium.',
        iconName: 'ausbildung.png',
        name: 'ausbildung-studium',
        tracking_name: '01/ausbildung_studium'
			},{
				index: 3,
				title: 'Ich ziehe um.',
        iconName: 'umzug.png',
        name: 'umzug',
        tracking_name: '01/umzug'
			},{
				index: 4,
				title: 'Ich möchte wissen, welche Versicherungen wichtig sind.',
        iconName: 'information.png',
        name: 'information-versicherungen',
        tracking_name: '01/wichtige_versicherungen'
      }],

      // trackBaseDomain: 'https://www.vkb.de',
      // trackCardName: '',
      // trackEventHome: 'CTA_JuLe_Home',
      // trackEventPage: 'CTA_JuLe',
      // trackPageBase: '/content/versicherungen/beratung/junge-leute/',
      // trackPageViewType: 'VKB_JuLe',
      trackingModuleType: 'bedarfscheck'
    };
  },
  computed: {
    ...mapState([
      'appConfigs'
    ]),

    config () {
      return this.appConfigs[this.$options.configIndex] || {};
    },

    apiRequest () {
      return apiCallers[this.config.app];
    },

    currentTheme() {
      return this.config.theme;
    },

    favorite_count() {
      return this.insurances
        .filter(ins => ins.is_favorite)
        .length;
    },

    disclimer_url() {
      const ds_urls = {
        vkb: 'https://www.vkb.de/datenschutz',
        fsoel: 'https://www.feuersozietaet.de/datenschutz',
      };

      return this.config && this.config.ds_url
        ? this.config.ds_url
        : ds_urls[this.currentTheme];
    },

    currentStep() {
      const step = this.cards.find(c => c.index === this.cardIndex);
      return step ? step.name : '';
    }
  },
  methods: {
    decodeHtml (value) {
      return value
        ? Base64.decode(value)
        : '';
    },


    loadInsurances() {
      if (
        (this.cardIndex === 1 || this.cardIndex === 2 || this.cardIndex === 4) &&
        !this.housingIndex
      ) {
        return;
      }

      if (
        (this.cardIndex === 2 || this.cardIndex === 3) &&
        !this.educationIndex
      ) {
        return;
      }

      const params = {
        step: this.currentStep,
        housing: this.housingIndex,
        education: this.educationIndex,
        customer: this.currentTheme
      };

      return this.apiRequest
        .get(this.config.paths.calc, {
          params
        })
        .then(res => {
          this.insurances = res.data.insurances || [];
          if (!this.insurances.length) {
            return;
          }

          this.insurances = this.insurances.map(ins => ({
            ...ins,
            calculate_online_url: ins.calculate_online_url,
            is_favorite: false
          }));

          this.$nextTick(() => {
            this.scrollToElement('recommend', 0);
          });
        });
    },

    onSelectCard(card) {
      this.cardIndex = card.index;
      this.housingIndex = 0;
      this.educationIndex = 0;
      this.mailRequestSent = false;
      this.insurances = [];
      this.scrollToElement('housing', 0);
      this.triggerActionEvent(card.tracking_name, this.trackingModuleType);

      // let properties = {
      //   text: this.trackCardName,
      //   pagename: this.trackPageBase
      // };

      // this.trackEvent(this.trackEventHome, properties);

      // let context = {
      //   type: this.trackPageViewType,
      //   data: [ this.trackCardName ]
      // };
      // let url = `${ this.trackBaseDomain }${ this.trackPageBase }${ this.trackCardName }/`;

      // this.trackPageView(context, url);
    },

    onSelectHousing(e, actionType = null) {
      this.mailRequestSent = false;
      this.housingIndex = parseInt(e.target.value, 10);
      this.loadInsurances();
      this.triggerActionEvent(actionType, this.trackingModuleType);
    },

    onSelectEducation(e, actionType = null) {
      this.mailRequestSent = false;
      this.educationIndex = parseInt(e.target.value, 10);
      this.loadInsurances();
      this.triggerActionEvent(actionType, this.trackingModuleType);
    },

    onSelectInsurance(index) {
      this.insurances[index].is_favorite = !this.insurances[index].is_favorite;

      // if (this.currentTheme !== 'vkb') {
      //   return;
      // }

      // let eventText = this.insurances[index].is_favorite
      //   ? 'Hinzugefügt'
      //   : 'Entfernt';

      // this.trackForFavorite(eventText);
    },

    onRemoveFavorite(index) {
      this.insurances[index].is_favorite = false;

      // if (this.currentTheme !== 'vkb') {
      //   return;
      // }

      // this.trackForFavorite('Entfernt');
    },

    onCheckAgree() {
      this.agreeChecked = !this.agreeChecked;
    },

    onClickCalcInfo (url = null) {
      if (!url) {
        return;
      }

      window.open(url, '_top');
    },

    setEmailAddress(value) {
      this.showError = false;
      this.emailAddress = value;
    },

    initEmail() {
      this.mailRequestSent = false;
      this.agreeChecked = false;
      this.emailAddress = '';
    },

    sendEmail() {
      if (!this.agreeChecked || this.mailRequestSent) {
        return ;
      }

      if (this.$v.$invalid) {
        this.showError = true;
        return ;
      }

      let params = {
        email: this.emailAddress,
        customer: this.currentTheme,
        favorites: this.insurances.filter(item => item.is_favorite).map(item => item.name),
        products: this.insurances
          .map(item => ({
            product_name: item.name,
            link: item.more_info_url ? item.more_info_url : item.calculate_online_url
          }))
      };

      this.mailRequestSent = true;
      this.apiRequest
        .post(this.config.paths.email, params)
        .finally(() => {
          this.initEmail();
        });
    },

    // trackForButton(eventText) {
    //   if (!this.cardIndex) {
    //     return;
    //   }

    //   let properties = {
    //     text: eventText,
    //     pagename: `${ this.trackPageBase }${ this.trackCardName }/`
    //   };

    //   this.trackEvent(this.trackEventPage, properties);

    //   if (this.insurances.length > 0) {
    //     let context = {
    //       type: this.trackPageViewType,
    //       data: [ 'empfohlene-versicherungen' ]
    //     };
    //     let url = `${ this.trackBaseDomain }${ this.trackPageBase }${ this.trackCardName }/empfohlene-versicherungen/`;

    //     this.trackPageView(context, url);
    //   }
    // },

    // trackForFavorite(eventText) {
    //   if (!this.cardIndex) {
    //     return;
    //   }

    //   let properties = {
    //     favoriten: eventText,
    //     pagename: `${ this.trackPageBase }${ this.trackCardName }/empfohlene-versicherungen/`
    //   };

    //   this.trackEvent(this.trackEventPage, properties);
    // }
  },

  validations: {
    emailAddress: {
      required,
      email
    }
  }
};


// WEBPACK FOOTER //
// ./src/apps/jule_2018/logic.js